import EnsureUtil from "utils/EnsureUtil.js";
import ConvertUtil from "utils/ConvertUtil.js";
import CoordinateUtil from "utils/CoordinateUtil.js";
import DateTimeUtil from "utils/DateTimeUtil.js";

export class Point {
  dbKey: any;
  id: any;
  accuracy: number;
  calories: number;
  heartRate: number;
  latitude: number;
  longitude: number;
  bearing: number;
  pauseInSecond: number;
  speedInMPS: number;
  elevationInMeter: number;
  realElevationInMeter: any;
  speedInKMH: number;
  distanceFromStartPointInMeter: number;
  timeFromStartPointInSecond: number;
  pauseTimeFromStartPointInSecond: number;
  unixTimestamp: number;
  isCountDown: boolean;
  date: any;
  dateFull: any;
  distanceFromPreviousPointInMeter?: number;

  constructor(dbPoint: any) {
    this.dbKey = dbPoint.key;

    if (dbPoint.m === undefined) {
      this.id = dbPoint.id;
    } else {
      this.id = dbPoint.m;
    }

    this.accuracy = EnsureUtil.ensurePositiveNumber(dbPoint.a);
    this.calories = EnsureUtil.ensurePositiveNumber(dbPoint.c);
    this.heartRate = EnsureUtil.ensurePositiveNumber(dbPoint.h);
    this.latitude = EnsureUtil.ensureNumber(dbPoint.l);
    this.longitude = EnsureUtil.ensureNumber(dbPoint.n);
    // Bearing: use -1 for invalid/missing values (null, undefined, NaN), not 0 (0 is a valid bearing - North)
    this.bearing = dbPoint.r !== null && dbPoint.r !== undefined && !isNaN(dbPoint.r) ? dbPoint.r : -1;
    this.pauseInSecond = EnsureUtil.ensurePositiveNumber(dbPoint.p);
    this.speedInMPS = EnsureUtil.ensurePositiveNumber(dbPoint.s);
    this.elevationInMeter = EnsureUtil.ensurePositiveNumber(dbPoint.e);
    this.realElevationInMeter = dbPoint.e;
    this.speedInKMH = ConvertUtil.convertMPSToKMH(this.speedInMPS);
    this.distanceFromStartPointInMeter = 0;
    this.timeFromStartPointInSecond = 0;
    this.pauseTimeFromStartPointInSecond = 0;
    this.unixTimestamp = EnsureUtil.ensurePositiveNumber(dbPoint.t);
    if (!this.id) {
      this.isCountDown = false;
    } else {
      const pointId = this.id.toLowerCase();
      this.isCountDown = pointId.includes("countdown") || pointId.includes("cnt");
    }
    this.date = DateTimeUtil.removeTimeFromDate(DateTimeUtil.getDateByTimeStamp(dbPoint.t));
    this.dateFull = DateTimeUtil.getDateByTimeStamp(dbPoint.t);
  }
}

export const calculateTimeAndDistanceOfPoints = (points: any[]): any[] => {
  const output: any[] = [];

  if (points.length === 0) {
    return output;
  }

  let distanceBetweenTwoCoordInMeter = 0;
  let distanceFromStartPointInMeter = 0;
  let timeFromStartPointInSecond = 0;
  let pauseTimeFromStartPointInSecond = 0;

  const startPoint = points[0];
  startPoint.distanceFromStartPointInMeter = 0;
  startPoint.distanceFromPreviousPointInMeter = 0;
  startPoint.timeFromStartPointInSecond = 0;
  startPoint.pauseTimeFromStartPointInSecond = 0;

  let previousPoint: any;
  let currentPoint: any;
  let previousPointCoord: any;
  let currentPointCoord: any;

  output.push(startPoint);

  for (let index = 1; index < points.length; index++) {
    previousPoint = points[index - 1];
    currentPoint = points[index];

    previousPointCoord = {latitude: previousPoint.latitude, longitude: previousPoint.longitude};
    currentPointCoord = {latitude: currentPoint.latitude, longitude: currentPoint.longitude};

    distanceBetweenTwoCoordInMeter = CoordinateUtil.calculateDistanceBetweenCoordinateInMeter(
      previousPointCoord,
      currentPointCoord
    );
    distanceFromStartPointInMeter = distanceFromStartPointInMeter + distanceBetweenTwoCoordInMeter;
    currentPoint.distanceFromStartPointInMeter = distanceFromStartPointInMeter;
    currentPoint.distanceFromPreviousPointInMeter = distanceBetweenTwoCoordInMeter;

    timeFromStartPointInSecond = currentPoint.unixTimestamp - startPoint.unixTimestamp;
    currentPoint.timeFromStartPointInSecond = timeFromStartPointInSecond;

    pauseTimeFromStartPointInSecond = pauseTimeFromStartPointInSecond + (currentPoint.pauseInSecond || 0);
    currentPoint.pauseTimeFromStartPointInSecond = pauseTimeFromStartPointInSecond;

    output.push(currentPoint);
  }

  return output;
};

export const sortDbPoints = (points: any[] | null): any[] | null => {
  if (points === null || points.length <= 1) {
    return points;
  }

  points = [...points].sort((a, b) => a.t - b.t);

  const startPoint = points[0];
  const endPoint = points[points.length - 1];

  if (startPoint.t > endPoint.t) {
    return points.reverse();
  }

  return points;
};
